import React from 'react';
import Checkbox from '../../Checkbox';

function CellWithCheckbox({ value, onChecked = null }) {
    return (
        <span className="table-cell_with-checkbox">
            <Checkbox label="" checked={value} onChange={onChecked} />
        </span>
    );
}


export default CellWithCheckbox;
